module.exports = __webpack_public_path__ + "img/VipVip.ea3272b7.png";